import Icon from '../components/Icon.vue'

Icon.register({
  'toilet-paper': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M128 0C75 0 32 86 32 192V364.1C32 405.2 22.2 426.8 0.8 490.9-2.6 501.3 5.1 512 16 512H296.9C310.7 512 322.9 503.2 327.3 490.1 340.1 451.6 352 417.7 352 364.1V192C352 108.4 375.7 38.5 412.4 0H128zM96 224C87.2 224 80 216.8 80 208S87.2 192 96 192 112 199.2 112 208 104.8 224 96 224zM160 224C151.2 224 144 216.8 144 208S151.2 192 160 192 176 199.2 176 208 168.8 224 160 224zM224 224C215.2 224 208 216.8 208 208S215.2 192 224 192 240 199.2 240 208 232.8 224 224 224zM288 224C279.2 224 272 216.8 272 208S279.2 192 288 192 304 199.2 304 208 296.8 224 288 224zM480 0C427 0 384 86 384 192S427 384 480 384 576 298 576 192 533 0 480 0zM480 256C462.3 256 448 227.3 448 192S462.3 128 480 128 512 156.6 512 192 497.7 256 480 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toilet-paper.js
// module id = l1Sb
// module chunks = 144